import { render, staticRenderFns } from "./MindfulSurveyThanks.vue?vue&type=template&id=db2c82ec&"
import script from "./MindfulSurveyThanks.vue?vue&type=script&lang=js&"
export * from "./MindfulSurveyThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports